import React, { useContext, useState, useEffect } from "react";
import close_modal from "../../assets/images/close_modal.svg";
import close_modal_dark from "../../assets/images/close_modal_dark.svg";
import BootstrapSpinner from "../../sharedComponent/BootstrapSpinner";
import { AppContext } from "../../context/AppContext";
import { ToWords } from "to-words";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from '../../assets/images/wifi-attendance.svg'
import { displayDateFormat, isEmptyObject } from "../../common";
import { PDFExport } from "@progress/kendo-react-pdf";

const GoodsInvoiceView = ({
  previewTaxInvoiceData,
  isView,
  setIsView,
  previewLoader,
}) => {
  const {
    units,
    Dark,
    logo,
    company_details,
    setProductNameWidth,
    hideBothSide,
    setHideBothSide,
    appSettings,
    userData
  } = useContext(AppContext);

  const toWords = new ToWords();
  const container = React.useRef(null);
  const pdfExportComponent = React.useRef(null);
  var commaNumber = require("comma-number");
  const [jpegCheck, setJpegCheck] = useState(false);
  const [pdfCheck, setpdfCheck] = useState(false);
  //   const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const amountInWords = toWords.convert(
    previewTaxInvoiceData && previewTaxInvoiceData.totalAmount
      ? previewTaxInvoiceData.totalAmount
      : 0,
    {
      currency: true,
    }
  );

  const [discountVal, setDiscountVal] = useState(JSON.parse(localStorage.getItem("appSettings")) || {});
  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("appSettings"));
    if (storedValue) {
      setDiscountVal(storedValue);
    }
  }, []);

  const isStateSame =
    previewTaxInvoiceData?.suppGSTNo?.substring(0, 2) ===
      previewTaxInvoiceData?.placeOfSupply?.split("-")[1]
      ? true
      : previewTaxInvoiceData?.placeOfSupply === ""
        ? true
        : false;

  return (
    <div>
      <Modal
        className="sales-home-modal purchase-view-modal"
        size="lg"
        show={isView}
        onHide={() => setIsView(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Body>
          <div className="btnCloseRper">
            <div>
              <Link
                to="#"
                className="text-white"
                onClick={() => {
                  setIsView(false);
                  // setHideCopy(false);
                  // setJpegCheck(false);
                  // setpdfCheck(false);
                }}
              >
                {Dark === "lightMode" ? (
                  <img
                    src={close_modal}
                    alt=""
                    // onClick={() => setPrint(false)}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    src={close_modal_dark}
                    alt=""
                    // onClick={() => setPrint(false)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </Link>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ marginRight: "15px" }}>
                {/* <button
                  disabled={loader ? true : false}
                  className="salesCopyBtn text-white rpsCopyBtn"
                  type="submit"
                  style={{
                    width: "139px",
                    height: "25px",
                    textAlign: "center",
                    border: "none",
                  }}
                  onClick={(e) => {
                    postInvoiceGovernment(previewTaxInvoiceData.id);
                  }}
                >
                  {loader ? (
                    <div
                      className="spinner-border text-secondar"
                      role="status"
                      style={{
                        width: "1rem",
                        height: "1rem",
                        margin: "-2 -2",
                      }}
                    >
                      <span className="sr-only mt-3"></span>
                    </div>
                  ) : (
                    "Generate E-Invoice"
                  )}
                </button> */}
                {/* <Link
                            className="salesCopyBtn text-white rpsCopyBtn"
                            onClick={() => {
                              postInvoiceGovernment(previewTaxInvoiceData?.id)
                            }}
                          >
                            Generate E-Invoice
                          </Link> */}
              </div>
              {/* {printButton && (
                <div style={{ marginRight: "15px" }}>
                  <Link
                    className="salesCopyBtn text-white rpsCopyBtn"
                    onClick={() => {
                      setPrint(true);
                      getTaxInvoiceData();
                      setIsView(false);
                    }}
                  >
                    Print
                  </Link>
                </div>
              )} */}
              {/* {hideCopy == false ? (
                <div>
                  <Link
                    to="#"
                    className="salesCopyBtn text-white rpsCopyBtn"
                    onClick={() => {
                      setIsView(false);
                      getCopyTaxInvoiceData(previewTaxInvoiceData.id);
                    }}
                  >
                    Copy
                  </Link>
                </div>
              ) : (
                ""
              )} */}
              {/* {jpegCheck && (
                <div>
                  <Link
                    to="#"
                    onClick={() => {
                      exportComponentAsJPEG(container);
                    }}
                    className="salesCopyBtn text-white rpsCopyBtn"
                  >
                    JPEG
                  </Link>
                </div>
              )} */}
              {/* {pdfCheck && (
                <div>
                  <Link
                    to="#"
                    onClick={exportPDFWithComponent}
                    className="salesCopyBtn text-white rpsCopyBtn"
                  >
                    PDF
                  </Link>
                </div>
              )} */}
            </div>
          </div>

          {/* ======================= PPreview Modal =================== */}

          <div>
            <PDFExport
              ref={pdfExportComponent}
              paperSize="auto"
              margin={40}
              fileName={`Report for ${new Date().getFullYear()}`}
              author="KendoReact Team"
            >
              {previewLoader ? (
                <div style={{ margin: "50%" }}>
                  <BootstrapSpinner />
                </div>
              ) : (previewTaxInvoiceData &&
                !isEmptyObject(previewTaxInvoiceData)) > 0 ? (
                <div
                  ref={container}
                  className="main-invoice-card dont-print-that"
                >
                  <div className="invoice-inner-main">
                    <div className="text-invoice-main">
                      <div className="text-invoice-inner coninversereponsive">
                        <div className="left">
                          <div className="text-invoice-heading">
                            <label htmlFor="">Tax Invoice</label>
                          </div>
                          <div className="invoice-date-number">
                            <label htmlFor="">
                              {previewTaxInvoiceData.invoiceNo}
                            </label>
                            <label htmlFor="">
                              Date: &nbsp;
                              <span>
                                {displayDateFormat(
                                  appSettings?.dateFormat,
                                  previewTaxInvoiceData?.invoiceDate
                                )}
                              </span>
                            </label>
                            <label htmlFor="">
                              Due Date: &nbsp;
                              <span>
                                {displayDateFormat(
                                  appSettings?.dateFormat,
                                  previewTaxInvoiceData?.dueDate
                                )}
                              </span>
                            </label>
                          </div>
                        </div>

                        <div className="right">
                          <img
                            src={userData?.CompanyLogo}
                            alt=""
                            onError={(e) => e.target.src = Logo}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="name-details-main">
                      <div className="name-details-inner row">
                        <div className="col-lg-7 left p-0">
                          <div className="name">
                            <label htmlFor="">
                              {previewTaxInvoiceData.suppName}
                            </label>
                          </div>
                          <div className="address">
                            <div>
                              <label htmlFor="" id="address">
                                {previewTaxInvoiceData.suppAddr}
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" className="contact">
                                Email Id :
                                <span> {previewTaxInvoiceData.suppEmail}</span>
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" className="contact">
                                Contact No:
                                <span>
                                  {" "}
                                  {previewTaxInvoiceData.suppContactNo}
                                </span>
                              </label>
                            </div>
                            {appSettings && appSettings.isGSTApplicable && (
                              <div>
                                <label htmlFor="" className="gst-no">
                                  GST No. :{" "}
                                  <span> {previewTaxInvoiceData.suppGSTNo}</span>
                                </label>
                              </div>)}
                            <div>
                              <label htmlFor="" className="pan-no">
                                PAN No. :{" "}
                                <span>{previewTaxInvoiceData?.suppPANNo}</span>
                              </label>
                            </div>
                            {previewTaxInvoiceData?.poNo && (
                              <div>
                                <label htmlFor="" className="pan-no">
                                  P.O No. :{" "}
                                  <span>{previewTaxInvoiceData?.poNo}</span>
                                </label>
                              </div>
                            )}
                            {previewTaxInvoiceData?.poDate && (
                              <div>
                                <label htmlFor="" className="pan-no">
                                  PO Date :{" "}
                                  <span>
                                    {displayDateFormat(
                                      appSettings.dateFormat,
                                      previewTaxInvoiceData?.poDate
                                    )}
                                  </span>
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-5 right p-0">
                          <div className="place-heading">
                            <label htmlFor="">Place of Supply:</label>
                          </div>
                          <div className="place">
                            <label htmlFor="">
                              {previewTaxInvoiceData.placeOfSupply}
                            </label>
                          </div>
                          <div className="place-heading">
                            <label htmlFor="">Mode of Payment:</label>
                          </div>
                          <div className="place">
                            {/* <label htmlFor="">Cash/Cheque.</label>{" "} */}
                            <span>{previewTaxInvoiceData.modeOfPay}</span>
                            <br />
                            {previewTaxInvoiceData.modeOfPay === "Cheque" && (
                              <>
                                <label htmlFor="">
                                  Cheque No.{" "}
                                  <span>{previewTaxInvoiceData.chequeNo}</span>
                                </label>
                                <br />
                                <label htmlFor="">
                                  {previewTaxInvoiceData.bankName}
                                </label>
                              </>
                            )}
                          </div>
                          <div className="place-heading ">
                            <label htmlFor="">Mode Of Transport:</label>
                          </div>
                          <div className="place">
                            <label htmlFor="">
                              {previewTaxInvoiceData.modeOfTransport}
                            </label>
                          </div>

                          {previewTaxInvoiceData.modeOfTransport ===
                            "By Road" && (
                              <>
                                <div className="place-heading ">
                                  <label htmlFor="">Vehicle No.</label>
                                </div>
                                <div className="place">
                                  <label htmlFor="">
                                    {previewTaxInvoiceData.vehicleNumber}
                                  </label>
                                </div>
                              </>
                            )}
                          {previewTaxInvoiceData?.lutBondNo && (
                            <>
                              <div className="place-heading ">
                                <label htmlFor="">LUT Bond No</label>
                              </div>
                              <div className="place">
                                <label htmlFor="">
                                  {previewTaxInvoiceData?.lutBondNo}
                                </label>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="name-details-main" id="info">
                      <div className="name-details-inner row">
                        <div className="col-lg-7 left p-0">
                          <div className="name">
                            <label htmlFor="" id="small-heading">
                              Bill To,
                            </label>

                            <br />
                          </div>
                          <div className="address">
                            <div>
                              <label htmlFor="">
                                {previewTaxInvoiceData.custName}
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" id="address">
                                {previewTaxInvoiceData.billAddr}
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" className="contact">
                                Email Id:
                                <span> {previewTaxInvoiceData.billEmail}</span>
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" className="contact">
                                Contact No:
                                <span>
                                  {" "}
                                  {previewTaxInvoiceData.billContactNo}
                                </span>
                              </label>
                            </div>
                            {appSettings && appSettings.isGSTApplicable && (
                              <div>
                                <label htmlFor="" className="gst-no">
                                  GST:{" "}
                                  <span>{previewTaxInvoiceData.billGSTNo}</span>
                                </label>
                              </div>)}
                            {previewTaxInvoiceData.billState && (
                              <div>
                                <label htmlFor="" className="gst-no">
                                  State :{" "}
                                  <span>
                                    {previewTaxInvoiceData.billState}{" "}
                                  </span>
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                        {previewTaxInvoiceData?.shipCustName ? (
                          <div className="col-lg-5 right p-0">
                            <div className="name">
                              <label htmlFor="" id="small-heading">
                                Ship To,{" "}
                              </label>

                              <br />
                            </div>
                            <div className="address">
                              <div>
                                <label htmlFor="">
                                  {previewTaxInvoiceData.shipCustName}
                                </label>
                              </div>
                              <div>
                                <label htmlFor="" id="address">
                                  {previewTaxInvoiceData.shipAddr}
                                </label>
                              </div>
                              <div>
                                <label htmlFor="" className="contact">
                                  Email Id :
                                  <span>
                                    {" "}
                                    {previewTaxInvoiceData.shipEmail}
                                  </span>
                                </label>
                              </div>
                              <div>
                                <label htmlFor="" className="contact">
                                  Contact No:
                                  <span>
                                    {" "}
                                    {previewTaxInvoiceData.shipContactNo}
                                  </span>
                                </label>
                              </div>
                              {appSettings && appSettings.isGSTApplicable && (
                                <div>
                                  <label htmlFor="" className="gst-no">
                                    GST:{" "}
                                    <span>
                                      {previewTaxInvoiceData.shipGSTNo}{" "}
                                    </span>
                                  </label>
                                </div>)}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="detail-table-main" id="modal-in-tab">
                      <table>
                        <thead>
                          <tr className="heading-row">
                            <td>#</td>
                            <td>Product Name/Service Name</td>
                            <td>HSN/SAC</td>
                            <td>Quantity</td>
                            <td>Rate</td>
                            <td>Unit</td>
                            <td>Disc. <span>{discountVal.discType === "Amount" ? `(₹)` : `(%)`}</span></td>
                            <td>Amount</td>

                            <td >CGST</td>
                            <td >SGST</td>

                            {/* {appSettings && appSettings.isGSTApplicable && (
                              isStateSame) ? (
                              <>
                                <td colSpan="2">CGST</td>
                                <td colSpan="2">SGST</td>
                              </>
                            ) : (
                              <>
                                {appSettings && appSettings.isGSTApplicable && (
                                  <td colSpan="2">IGST</td>)}
                              </>
                            )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {previewTaxInvoiceData.invoiceDetails &&
                            previewTaxInvoiceData.invoiceDetails.length > 0 &&
                            previewTaxInvoiceData.invoiceDetails.map(
                              (invDetails, index) => {
                                let unit =
                                  units &&
                                  units.filter((item) => {
                                    return item.id === invDetails.unitId;
                                  })[0]?.unit;
                                return (
                                  <tr key={invDetails.id}>
                                    <td>{index + 1}</td>
                                    <td>{invDetails.productName}</td>
                                    <td>{invDetails.hsnCode}</td>
                                    <td>{invDetails.qty}</td>
                                    <td>{invDetails.rate}</td>
                                    <td>{invDetails.unit}</td>
                                    <td>
                                      {invDetails.discPer}
                                      {appSettings?.discType === "Amount"
                                        ? ""
                                        : "%"}
                                    </td>
                                    <td>{invDetails.discAmount}</td>
                                    <td>{invDetails.cgst}</td>
                                    <td>{invDetails.sgst}</td>
                                    {/* {appSettings && appSettings.isGSTApplicable && (
                                      isStateSame) ? (
                                      <>
                                        <td>{invDetails.cgst}%</td>
                                        <td>{invDetails.cgstAmount}</td>
                                        <td>{invDetails.sgst}%</td>
                                        <td>{invDetails.sgstAmount}</td>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <td>{invDetails.igst}%</td>)}
                                        {appSettings && appSettings.isGSTApplicable && (

                                          <td>Rs. {invDetails.igstAmount}</td>)}
                                      </>
                                    )} */}
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </table>
                    </div>
                    <div className="sub-total-section">
                      <div className="bank-details">
                        {previewTaxInvoiceData?.bankDetails && (
                          <label htmlFor="">Bank Details :</label>
                        )}
                        {previewTaxInvoiceData?.bankDetails &&
                          previewTaxInvoiceData?.bankDetails
                            .split("\r\n")
                            .map((str, i) => {
                              return (
                                <div
                                  key={i + "bankDetails"}
                                  className="bank-sub"
                                >
                                  <label htmlFor="">{str && str}</label>
                                </div>
                              );
                            })}
                      </div>
                      <div className="right-section">
                        <div className="left">
                          <div className="text-sub">
                            <label htmlFor="">Sub Total</label>
                          </div>
                          {appSettings && appSettings.isGSTApplicable &&
                            (!isStateSame ||
                              previewTaxInvoiceData?.isSEZEnabled) ? (
                            <div className="text-sub">
                              <label htmlFor="">IGST</label>
                            </div>
                          ) : (
                            <>
                              {appSettings && appSettings.isGSTApplicable && (
                                <div className="text-sub">
                                  <label htmlFor="">CGST</label>
                                </div>)}
                              {appSettings && appSettings.isGSTApplicable && (
                                <div className="text-sub">
                                  <label htmlFor="">SGST</label>
                                </div>)}
                            </>
                          )}
                          {appSettings && appSettings.isRoundOff && (
                            <div className="text-sub">
                              <label htmlFor="">Round off</label>
                            </div>
                          )}
                        </div>
                        <div className="right">
                          <div className="sub-total">
                            <label htmlFor="">
                              Rs. {previewTaxInvoiceData?.subTotal?.toFixed(2)}
                            </label>
                          </div>
                          {appSettings && appSettings.isGSTApplicable && (
                            isStateSame) ? (
                            <>
                              <div className="sub-total">
                                <label htmlFor="">
                                  Rs. {previewTaxInvoiceData.cgstAmount}
                                </label>
                              </div>
                              <div className="sub-total">
                                <label htmlFor="">
                                  Rs. {previewTaxInvoiceData.sgstAmount}
                                </label>
                              </div>
                            </>
                          ) : (
                            <>
                              {appSettings && appSettings.isGSTApplicable && (
                                <div className="sub-total">
                                  <label htmlFor="">
                                    Rs. {previewTaxInvoiceData.igstAmount}
                                  </label>
                                </div>)}
                            </>
                          )}
                          {appSettings && appSettings.isRoundOff && (
                            <div className="sub-total">
                              <label htmlFor="">
                                Rs.{" "}
                                {previewTaxInvoiceData?.roundOff?.toFixed(2) ||
                                  "0.00"}
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mainsub-total"></div>
                    <div className="total-amt-main">
                      <div
                        className="total-amount-section"
                        id="sub-total-section"
                      >
                        <div
                          style={{
                            display: "flex",
                            marginRight: "250px",
                            alignItems: "left",
                            fontSize: "12px"
                          }}
                        >
                          <label htmlFor=""> <b>Payments Terms : </b>
                          </label>
                          <label htmlFor="">
                            &nbsp;
                            {previewTaxInvoiceData?.paymentTerms}
                          </label>
                        </div>
                        <div className="left">
                          <div className="text-sub">
                            <label htmlFor="">Total Amount</label>
                          </div>
                        </div>
                        <div className="right">
                          <div className="sub-total">
                            <label htmlFor="">
                              Rs.{" "}
                              {commaNumber(
                                Math.round(
                                  previewTaxInvoiceData.totalAmount
                                ).toFixed(2)
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="in-word">
                        <label htmlFor="">{amountInWords}</label>
                      </div>
                    </div>
                    <div className="line-total"></div>
                    <div className="disc-sign-main row">
                      {/* <div className="col-lg-4 left ps-0">
                                  <div className="description">
                                    <textarea
                                      className="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      placeholder="Declaration"
                                    ></textarea>
                                  </div>
                                </div> */}
                      <div className="col-lg-7 left ps-0">
                        <div className="Terms-of-Services">
                          <div className="heading-TS">
                            <label htmlFor="">Terms and Conditions</label>
                          </div>
                          <div className="term-conditions">
                            {company_details?.terms
                              ? company_details.terms
                              : ""}
                          </div>
                          {/* <ul>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                      <li>Terms of Services</li>
                                    </ul> */}
                        </div>
                      </div>
                      <div className="col-lg-5 right pe-0 ps-0">
                        <div className="upload">
                          {Dark === "lightMode" ? (
                            <img
                              src={
                                company_details?.signtureLogo
                                  ? company_details?.signtureLogo
                                  : ""
                              }
                              alt=""
                            />
                          ) : (
                            <img
                              src={
                                company_details?.signtureLogo
                                  ? company_details?.signtureLogo
                                  : ""
                              }
                              alt=""
                            />
                          )}{" "}
                          {/* <br />
                                    <label htmlFor="" className="text-up">
                                      Upload your signature
                                    </label>
                                  */}
                          <br />
                          <label htmlFor="" className="text-auth">
                            Authorized Signature
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </PDFExport>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GoodsInvoiceView;
